import React, { useEffect, useState } from "react";
import SweetAlertModal from "../../../components/SweetAlertModal/SweetAlertModal";
import Cancel from "./../../../../assets/icons/close.png";
import itemImg from "./../../../../assets/icons/menu.png";
import CustomDataGrid from "../../../components/CustomDataGrid/CustomDataGrid.tsx";
import { ToastContainer, toast } from "react-toastify";

import MenuUnlinkModal from "../Unlink/MenuUnlinkModal.tsx";

import "./ArchiveDialog.css";

import axios from "axios";

import {
  Button,
  Grid,
  Switch,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";

function ArchiveDialog(props) {
  console.log(props);

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [openMenuCloseConfirmaitonModal, setopenMenuCloseConfirmaitonModal] =
    useState(false);
  const [openArchiveConfirmaitonModal, setopenArchiveConfirmaitonModal] =
    useState(false);
  const [openUnlinkConfirmaitonModal, setopenUnlinkConfirmaitonModal] =
    useState(false);
  const [openDeleteConfirmaitonModal, setopenDeleteConfirmaitonModal] =
    useState(false);
  const [selectedValue, setSelectedValue] = useState<any>(null);
  const [dataRows, setDataRows] = useState([]);

  const [selectedDataRows, setSelectedDatarows] = React.useState([]);

  const getselectedData = (props) => {
    console.log(props);
    setSelectedDatarows(props);
  };

  const handleClose = () => {
    //props.onHandleAddItem(restaurantId);
    // setKeyword(null)
    props.onClose();
    setSelectedValue(null);
    setopenMenuCloseConfirmaitonModal(false);
    setopenArchiveConfirmaitonModal(false);
    setOpenDialog(false);
    setRestaurantId([]);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRowId(null);
  };

  const {
    open,
    onClose,
    dialogType,
    id,
    cancledRes,
    Linkdata,
    onToggleSwitch,
    selectedRestaurants,
    openDialog: toggle,
    Status,
  } = props;

  console.log(id);
  console.log(cancledRes);

  const apiAddress = process.env.REACT_APP_SECRET;

  const [restaurantId, setRestaurantId] = useState([]);
  const [linkMenuId, setLinkMenuId] = useState([]);

  useEffect(() => {
    if (Status == "Single Archive") {
      if (cancledRes && cancledRes.length > 0) {
        let count = 0;
        count++;
        console.log(count);
        let canceledObjs = [];
        let canceledObj = {};
        cancledRes.forEach((dt) => {
          canceledObj = {
            restaurantId: dt.linkedRestaurantId,
            menuId: dt.linkedMenuId,
            activeMenu: null,
          };
          canceledObjs.push(canceledObj);
        });

        console.log(canceledObjs);

        var url = apiAddress + "/api/Menu/allmenuinfo";

        axios
          .post(url, canceledObjs)
          .then((response) => {
            console.log(response.data);

            var list = [];
            response.data.forEach((dt, i) => {
              var obj = {
                id: i,
                restaurantName: dt.restaurantName,
                menuName: dt.menuName,
                sectionName: dt.sectionName,
                foodName: dt.foodName,
                linkedMenuName: dt.linkedMenuName,
              };
              list.push(obj);
            });
            console.log(list);
            setDataRows(list);
          })
          .catch((error) => {
            console.error("Error occurred:", error.response.data);
          });
      }
    } else if (Status == "Bulk Archive") {
      if (cancledRes && cancledRes.length > 0) {
        let count = 0;
        count++;
        console.log(count);
        let canceledObjs = [];
        let canceledObj = {};
        cancledRes.forEach((dt) => {
          canceledObj = {
            restaurantId: dt.id,
            menuId: dt.linkedMenuId,
            activeMenu: dt.activeMenu,
          };
          canceledObjs.push(canceledObj);
        });

        console.log(canceledObjs);

        var url = apiAddress + "/api/Menu/allmenuinfo";

        axios
          .post(url, canceledObjs)
          .then((response) => {
            console.log(response.data);

            var list = [];
            response.data.forEach((dt, i) => {
              var obj = {
                id: i,
                restaurantName: dt.restaurantName,
                menuName: dt.menuName,
                sectionName: dt.sectionName,
                foodName: dt.foodName,
                linkedMenuName: dt.linkedMenuName,
              };
              list.push(obj);
            });
            console.log(list);
            setDataRows(list);
          })
          .catch((error) => {
            console.error("Error occurred:", error.response.data);
          });
      }
    }
  }, [cancledRes]);

  const archiveSubmit = () => {
    if (Status == "Single Archive") {
      if (cancledRes && cancledRes.length > 0) {
        let canceledObjs = [];
        let canceledObj = {};

        cancledRes.forEach((dt) => {
          canceledObj = {
            restaurantId: dt.id,
            menuId: dt.linkedMenuId,
          };
          canceledObjs.push(canceledObj);
          console.log(canceledObjs);
        });

        var url = apiAddress + "/api/Menu/menuarchived";

        axios.put(url, canceledObjs).then((response) => {
          console.log(response.data);
          toast.success("Menu Succesfully Archived", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          console.log(canceledObjs);
          props.onHandleArchiveItem(canceledObjs);
          setSelectedValue(null);
          setopenMenuCloseConfirmaitonModal(false);
          setopenArchiveConfirmaitonModal(false);
          setOpenDialog(false);
          //setRestaurantId([]);
          //cancledRes=[];
        });
      }
    } else if (Status == "Bulk Archive") {
      if (cancledRes && cancledRes.length > 0) {
        let canceledObjs = [];
        let canceledObj = {};
        cancledRes.forEach((dt) => {
          canceledObj = {
            restaurantId: dt.id,
            menuId: dt.linkedMenuId,
            activeMenu: dt.activeMenu,
          };
          canceledObjs.push(canceledObj);
          console.log(canceledObjs);
        });

        var url = apiAddress + "/api/Menu/menuBulkarchived";

        axios.put(url, canceledObjs).then((response) => {
          console.log(response.data);
          toast.success("Menu Succesfully Archived", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          console.log(canceledObjs);
          props.onHandleArchiveItem(canceledObjs);
          setSelectedValue(null);
          setopenMenuCloseConfirmaitonModal(false);
          setopenArchiveConfirmaitonModal(false);
          setOpenDialog(false);
          //setRestaurantId([]);
          //cancledRes=[];
        });
      }
    }
  };

  const unlinkSubmit = () => {
    if (Status == "Bulk Archive") {
      if (cancledRes && cancledRes.length > 0) {
        console.log(cancledRes);

        let canceledObjs = [];
        let canceledObj = {};

        cancledRes.forEach((dt) => {
          canceledObj = {
            restaurantId: dt.id,
            menuId: dt.linkedMenuId,
            activeMenuId: dt.activeMenu,
          };
          canceledObjs.push(canceledObj);
          console.log(canceledObjs);
        });
        var url = apiAddress + "/api/Menu/MenuUnlinkFromRes";

        axios.put(url, canceledObjs).then((response) => {
          console.log(response.data);
          toast.success("Menu Succesfully Unlinked", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          console.log();
          props.onHandleArchiveItem();
          setSelectedValue(null);
          setopenMenuCloseConfirmaitonModal(false);
          setopenArchiveConfirmaitonModal(false);
          setOpenDialog(false);
          //setRestaurantId([]);
          //cancledRes=[];
        });
      }
    }
  };

  const deleteSubmit = () => {
    if (Status == "Single Archive") {
      if (cancledRes && cancledRes.length > 0) {
        let deleteMenuIds = [];

        cancledRes.forEach((dt) => {
          deleteMenuIds.push(dt.linkedMenuId);
        });
        var url = apiAddress + "/api/Menu/DeleteMenu";

        axios.put(url, deleteMenuIds).then((response) => {
          console.log(response.data);
          toast.success("Menu Succesfully Deleted", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          console.log();
          props.onHandleArchiveItem();
          setSelectedValue(null);
          setopenMenuCloseConfirmaitonModal(false);
          setopenArchiveConfirmaitonModal(false);
          setOpenDialog(false);
          //setRestaurantId([]);
          //cancledRes=[];
        });
      }
    } else if (Status == "Bulk Archive") {
      if (cancledRes && cancledRes.length > 0) {
        let canceledObjs = [];
        let canceledObj = {};
        cancledRes.forEach((dt) => {
          canceledObj = {
            restaurantId: dt.id,
            menuId: dt.linkedMenuId,
            activeMenu: dt.activeMenu,
          };
          canceledObjs.push(canceledObj);
          console.log(canceledObjs);
        });

        var url = apiAddress + "/api/Menu/MenuBulkDelete";

        axios.put(url, canceledObjs).then((response) => {
          console.log(response.data);
          toast.success("Menu Succesfully Deleted", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          console.log();
          props.onHandleArchiveItem();
          setSelectedValue(null);
          setopenMenuCloseConfirmaitonModal(false);
          setopenArchiveConfirmaitonModal(false);
          setOpenDialog(false);
          //setRestaurantId([]);
          //cancledRes=[];
        });
      }
    }
  };
  const [openMenuUnlinkModal, setopenMenuUnlinkModal] = useState(false);

  const handleMenuUnlink = () => {
    if (Status == "Single Archive") {
      setopenMenuUnlinkModal(true);
    } else if (Status == "Bulk Archive") {
      setopenUnlinkConfirmaitonModal(true);
    }
  };

  const handleunlinkModalClose = () => {
    setopenMenuUnlinkModal(false);
    props.onClose();
  };

  return (
    <div>
      <React.Fragment>
        <Dialog maxWidth={"sm"} open={props.open} onClose={handleClose}>
          <SweetAlertModal
            headerText={"Do you want to leave without saving?"}
            bodyText={"All changes made will be lost"}
            open={openMenuCloseConfirmaitonModal}
            onyes={handleClose}
            close={() => {
              setopenMenuCloseConfirmaitonModal(false);
            }}
            id={2}
          />

          <SweetAlertModal
            headerText={"Are you sure?"}
            bodyText={"Do you want to archive this!"}
            open={openArchiveConfirmaitonModal}
            onyes={archiveSubmit}
            close={() => {
              setopenArchiveConfirmaitonModal(false);
            }}
          />
          <SweetAlertModal
            headerText={"Are you sure?"}
            bodyText={"Do you want to Unlink this!"}
            open={openUnlinkConfirmaitonModal}
            onyes={unlinkSubmit}
            close={() => {
              setopenUnlinkConfirmaitonModal(false);
            }}
          />
          <SweetAlertModal
            headerText={"Are you sure?"}
            bodyText={"Do you want to Delete this!"}
            open={openDeleteConfirmaitonModal}
            onyes={deleteSubmit}
            close={() => {
              setopenDeleteConfirmaitonModal(false);
            }}
          />
          <Grid container>
            <Grid item xs={6}>
              <DialogTitle>
                <div className="d-flex" style={{ gap: "8px" }}>
                  <div>
                    <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
                  </div>

                  <span style={{ color: "#2a7fd4" }}>
                    GoTaste :- {dialogType}
                  </span>
                </div>
              </DialogTitle>
            </Grid>

            <Grid item xs={6}>
              <DialogActions>
                <Button onClick={() => setopenMenuCloseConfirmaitonModal(true)}>
                  <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
          <DialogContent>
            {dataRows.length > 0 && Status == "Single Archive" && (
              <span>
                <p>
                  <b>{`{${dataRows.map((row) => row.menuName).join(", ")}}`}</b>{" "}
                  in{" "}
                  <b>{`{${dataRows
                    .map((row) => row.restaurantName)
                    .join(", ")}}`}</b>{" "}
                  will be removed.
                </p>
              </span>
            )}
            {dataRows.length > 0 && Status == "Bulk Archive" && (
              <span>
                <p>
                  {dataRows.length === 1 ? (
                    <>
                      <b>{`{${dataRows.length}}`}</b> Menu and related menu in{" "}
                      <b>{`{${dataRows.length}}`}</b> restaurant will be
                      removed.
                    </>
                  ) : (
                    <>
                      <b>{`{${dataRows.length}}`}</b> Menus and related menus in{" "}
                      <b>{`{${dataRows.length}}`}</b> restaurants will be
                      removed
                    </>
                  )}
                </p>
              </span>
            )}

            {/* <CustomDataGrid columns={columns} dataRows={dataRows}/> */}

            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center">Restaurant Name</TableCell>
                  {Status == "Bulk Archive" && (
                    <TableCell align="center">Related Menu</TableCell>
                  )}
                  <TableCell align="center">Related Section</TableCell>
                  <TableCell align="center">Related Items</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dataRows.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="center">{row.restaurantName}</TableCell>

                    {Status == "Bulk Archive" &&
                      row?.linkedMenuName !== null && (
                        <TableCell align="center">
                          {row.menuName + "," + row.linkedMenuName}
                        </TableCell>
                      )}
                    {Status == "Bulk Archive" &&
                      row?.linkedMenuName == null && (
                        <TableCell align="center">{row.menuName}</TableCell>
                      )}

                    <TableCell align="center">{row.sectionName}</TableCell>
                    <TableCell align="center">{row.foodName}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setopenArchiveConfirmaitonModal(true)}
              color="error"
            >
              Archive
            </Button>
            <Button
              onClick={() => setopenDeleteConfirmaitonModal(true)}
              color="error"
            >
              Delete
            </Button>
            {Linkdata?.length > 0 && (
              <Button onClick={handleMenuUnlink} color="error">
                Unlink Menu
              </Button>
            )}
            <Button
              onClick={() => setopenMenuCloseConfirmaitonModal(true)}
              color="primary"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
      {openMenuUnlinkModal && (
        <MenuUnlinkModal
          open={openMenuUnlinkModal}
          dialogType={"Menu Unlink"}
          onClose={handleunlinkModalClose}
          linkedMenu={cancledRes}
        />
      )}
    </div>
  );
}

export default ArchiveDialog;
